import LoaderCircle from '@components/loader-circle/LoaderCircle';
import { handleVisibleHeader } from '@lib/store/slices/ComponentsSlice';
import { setCurrentData, setEqualizerOpened, setSelectedBenefit } from '@lib/store/slices/EqualizerSlice';
import getValidbenefits from '@lib/tools/_getValidBenefits';
import { handleBodyLock } from '@lib/tools/_handle-body-lock';
import { handleBodyUnlock } from '@lib/tools/_handle-body-unlock';
import { useViewport } from '@lib/tools/hooks/useViewport';
import axios from 'axios';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CardCalculator } from './components/card-calculator/CardCalculator';
import CardProgram from './components/card-program/CardProgram';
import styles from './EqualizerCalculatorModal.module.scss';
const EqualizerCalculatorModal = ({
  flat
}) => {
  const dispatch = useDispatch();
  const {
    isMobile
  } = useViewport();
  const validMortgageBenefits = getValidbenefits(flat);
  const {
    selectedBenefit,
    currentData
  } = useSelector(state => state?.equalizer);
  //фильтрация по кнпокам
  const [isMinFirstPayment, setIsMinFirstPayment] = useState(false);
  const [isPercentageAmount, setIsPercentageAmount] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [period, setPeriod] = useState(selectedBenefit?.mortgage?.maxPeriod);
  const [payment, setPayment] = useState(selectedBenefit?.mortgage?.firstPayment);
  const [apiBenefits, setApiBenefits] = useState([]);
  const [programTypes, setProgramTypes] = useState([]);
  const [apiFilterBenefits, setApiFilterBenefits] = useState([]);
  useEffect(() => {
    dispatch(handleVisibleHeader(false));
    handleBodyLock();
    return () => {
      dispatch(handleVisibleHeader(true));
      handleBodyUnlock();
    };
  }, [dispatch]);

  //при открытии делаем запрос к пику с сохраненными данными
  //на случий повторного открытия эквалайзера из карточки
  useEffect(() => {
    fetchData(payment, period, selectedBenefit?.id);
    if (payment !== selectedBenefit?.mortgage?.minPrice) {
      setIsMinFirstPayment(false);
    }
  }, [payment, period]);

  //Собираем id всех ипотечных программ и сами программы,
  //чтобы перезаписывать их описание description для приходящих бенефитов с пика
  const idObj = useMemo(() => {
    const res = {};
    validMortgageBenefits.forEach(el => {
      res[el.id] = el;
    });
    return res;
  }, [validMortgageBenefits]);
  const fetchData = async (payment_0, period_0, benefitId) => {
    setIsLoading(true);
    try {
      const paymentNew = Math.max(Math.floor(payment_0), 1);
      const newPeriod = Math.floor(period_0);
      const url = `https://api.forma.ru/v2/flat/mortgage?flatId=${flat.id}&initialPayment=${paymentNew}&loanTerm=${newPeriod}&benefitId=${benefitId}`;
      const response = await axios.get(url);
      const mortgagesArr = response.data?.benefits?.mortgage || [];
      const filteredMortgageArr = [];
      mortgagesArr.filter(el_0 => el_0?.mortgage !== null && idObj[el_0.id]).sort((a, b) => a.mortgage.minMonthFee - b.mortgage.minMonthFee).forEach(el_1 => {
        // Создаем новый объект с обновленным описанием и именем
        //  находим  по ид из полученных от пик бенефитов те бенефиты,
        //  которые есть у нас в вдминке и перезаписываем их описание description на наше
        const newEl = {
          ...el_1,
          description: idObj[el_1.id]?.description,
          name: idObj[el_1.id]?.name
        };
        // Если id совпадает с benefitId, обрабатываем его отдельно
        if (newEl.id === benefitId) {
          dispatch(setCurrentData({
            ...currentData,
            currentFirstPayment: newEl.mortgage.firstPayment,
            currentMinMonthFee: newEl.mortgage.minMonthFee,
            currentBenefitPrice: newEl.benefitPrice,
            currentMortgageBenefit: newEl,
            currentLoanTerm: newEl.mortgage.maxPeriod
          }));
          dispatch(setSelectedBenefit(newEl));
          filteredMortgageArr.unshift(newEl); // Добавляем в начало
        } else {
          filteredMortgageArr.push(newEl); // Добавляем в конец
        }
      });
      // Устанавливаем результат
      setApiBenefits(filteredMortgageArr);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleCloseModal = () => {
    dispatch(setEqualizerOpened(false));
    dispatch(setCurrentData({
      ...currentData,
      currentLoanTerm: period,
      currentFirstPayment: payment,
      currentMortgageBenefit: selectedBenefit
    }));
  };
  const handleChangeCreditTerm = value => {
    setPeriod(value);
  };
  const handleOnChangeSlider = e => {
    if (e > selectedBenefit?.mortgage?.maxPrice) {
      setPayment(selectedBenefit?.mortgage?.maxPrice);
    } else {
      setPayment(e);
    }
  };
  const onChangeFirstPayment = e_0 => {
    if (isPercentageAmount) {
      //если значение в процентах (isPercentageAmount) вычисляется newPayment в рублях
      const newPayment = Number((e_0 / 100 * selectedBenefit?.benefitPrice).toFixed(0));
      if (newPayment > selectedBenefit?.mortgage?.maxPrice) {
        setPayment(selectedBenefit?.mortgage?.maxPrice);
      } else {
        setPayment(newPayment);
      }
    } else {
      //если значение в рублях, оно и устанавливается в текущий ПВ -payment
      if (e_0 > selectedBenefit?.mortgage?.maxPrice) {
        setPayment(selectedBenefit?.mortgage?.maxPrice);
      }
      setPayment(e_0);
    }
  };
  useEffect(() => {
    const activeItem = programTypes?.find(item => item?.active);
    //Сортировка по типам программ по чекбоксам калькулятора
    if (activeItem?.value === 'family') {
      const filteredArr = apiBenefits.filter(obj => obj?.isFamily);
      setApiFilterBenefits(filteredArr);
    } else if (activeItem?.value === 'standard') {
      const filteredArr_0 = apiBenefits.filter(obj_0 => !obj_0?.isFamily);
      setApiFilterBenefits(filteredArr_0);
    } else if (activeItem?.value === 'all') {
      setApiFilterBenefits(apiBenefits);
    }
  }, [programTypes, apiBenefits]);
  useEffect(() => {
    const hasFamily = apiBenefits?.some(item_0 => item_0?.isFamily);
    const hasStandard = apiBenefits?.some(item_1 => !item_1?.isFamily);
    const updatedProgramTypes = [{
      label: 'Все программы',
      value: 'all',
      active: true
    }];
    if (hasFamily) {
      updatedProgramTypes.push({
        label: 'Семейная',
        value: 'family',
        active: false
      });
    }
    if (hasStandard) {
      updatedProgramTypes.push({
        label: 'Стандартная',
        value: 'standard',
        active: false
      });
    }
    setProgramTypes(updatedProgramTypes);
  }, [apiBenefits]);
  return <div className={styles.overlay}>
      {isLoading && <LoaderCircle someStyles={styles.loadCircle} />}
      <div className={styles.modal}>
        <button onClick={handleCloseModal} className={styles.modal__closeBtn}>
          <svg width='32' height='33' viewBox='0 0 32 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M17.4406 16.5744L28.0472 5.96776L26.5794 4.5L15.9728 15.1066L5.39354 4.52731L3.92578 5.99507L14.5051 16.5744L3.95202 27.1274L5.41978 28.5952L15.9728 18.0421L26.5532 28.6225L28.021 27.1547L17.4406 16.5744Z' fill='#1C1C1C' />
          </svg>
        </button>
        <h1 className={styles.modal__title}>Выберите условия&nbsp;покупки</h1>
        <div className={styles.modal__inner}>
          <CardCalculator isMobile={isMobile} selectedBenefit={selectedBenefit} creditTerm={period} firstPayment={payment} isMinFirstPayment={isMinFirstPayment} isPercentageAmount={isPercentageAmount} handleOnChangeSlider={handleOnChangeSlider} onChangeFirstPayment={onChangeFirstPayment} handleChangeCreditTerm={handleChangeCreditTerm} onChangeCredit={handleChangeCreditTerm} setIsPercentageAmount={setIsPercentageAmount} setIsMinFirstPayment={setIsMinFirstPayment} setPayment={setPayment} programTypes={programTypes} setProgramTypes={setProgramTypes} />

          <div className={styles.modal__benefits}>
            {apiFilterBenefits?.map(benefit => {
            if (!benefit) return null;
            return <CardProgram key={benefit?.id} benefit={benefit} flat={flat} selectedBenefit={selectedBenefit} payment={payment} period={period} isMinFirstPayment={isMinFirstPayment} isMobile={isMobile} setPayment={setPayment} setPeriod={setPeriod} fetchData={fetchData} />;
          })}
          </div>
        </div>
      </div>
    </div>;
};
export default EqualizerCalculatorModal;